import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import {useDispatch} from "react-redux";
import React, {
    memo, useEffect, useRef, useState,
} from "react";
import {IconChevronDown, IconChevronUp} from "@searchComponents/icons";
import {setFilter} from "../store/actions";

const {createSliderWithTooltip} = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const FilterCardSlider = memo(({
                                   min, max, step, title, value,
                               }) => {
    const dispatch = useDispatch();
    const [price, setPrice] = useState([0, 10]);
    const filterCard = useRef(null);
    const [arrowDirection, setArrowDirection] = useState("down");

    const toggleFilter = () => {
        if ([...filterCard.current.classList].includes("active-filter")) {
            setArrowDirection("down");
            setTimeout(() => {
                filterCard.current.style.display = "block";
            }, 205);
        } else {
            setArrowDirection("up");
            setTimeout(() => {
                filterCard.current.style.display = "none";
            }, 205);
        }
        filterCard.current.classList.toggle("active-filter");
    };
    const onChangeAfter = (value) => {
        dispatch(setFilter(`price=${value}`));
    };

    const onChange = (value) => {
        setPrice(value);
    };

    useEffect(() => {
        setPrice(value);
    }, [value]);

    return (
        <div>
            <div
                tabIndex={0}
                aria-label={`Toon/Verberg opties voor ${title}`}
                role={"button"}
                onClick={toggleFilter}
                onKeyDown={(e) => {
                    if (["Enter", "Space"].includes(e.code)) {
                        e.preventDefault();
                        toggleFilter();
                    }
                }}>
            >
                <p>{title}</p>
                {arrowDirection === "down"
                    ? <IconChevronDown/>
                    : <IconChevronUp/>
                }
            </div>
            <div ref={filterCard}>
                {/* <div className="filter__card-title">{ title }</div>
          <div className="filter__card-content"> */}
                <div>
                    <Range min={min} max={Math.round(max)} step={step} onAfterChange={onChangeAfter} onChange={onChange}
                           value={price} tipProps={{placement: "bottom", visible: true}}
                           tipFormatter={(value) => `${value}`}/>
                </div>
            </div>
        </div>
    );
});

export default FilterCardSlider;
